import React from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import CompareCartValue from './CompareCartValue'
import { Line } from '@vds/lines';

class CompareCartHeader extends React.PureComponent {

    render() {
        let profileCartValue = ''
        let newCartValue = ''
        let profileName = ''
        let cartName = ''
        let profilePrice = ''
        let cartPrice = ''
        const isMobile = window.screen.width < 768;
        profileCartValue = <CompareCartValue profileCartList={this.props.profileCartValue} />
        newCartValue = <CompareCartValue newCartList={this.props.newCartValue} />

        if (this.props.profileCartValue != null && this.props.profileCartValue != undefined && this.props.profileCartValue != "" && this.props.profileCartValue.length > 0) {
            profileName = this.props.profileHeaderName != "" ? this.props.profileHeaderName : "";
            if (this.props.profileHeaderPrice != 0)
                profilePrice = ((this.props.profileHeaderPrice != undefined && this.props.profileHeaderPrice.includes("$0.0")) ? "$0.00" : this.props.profileHeaderPrice);
        }

        if (this.props.newCartValue != null && this.props.newCartValue != undefined && this.props.newCartValue != "" && this.props.newCartValue.length > 0) {
            cartName = this.props.cartHeaderName != "" ? this.props.cartHeaderName : "";
            if (this.props.cartHeaderPrice != 0)
                cartPrice = this.props.cartHeaderPrice;
        }
        
        return (
            <React.Fragment>
                <div className={profileName != undefined && profileName != null || cartName != undefined && cartName != null ? "row compare-row" : "hide"}>
                    <div className="columns tiny-6 padding-vert-zero">
                        <div id="BundleSectionCSR" className="padding-right-small">
                            <ul className="margin-left-zero">
                                <li id="BundleDetailsCSR" className="">
                                    <p className="margin-bottom-zero" style={{ display: profileName === "" ? 'none' : 'flex', position: 'relative' }}>
                                        <span id="BundleNameCSR" className="bold margin-bottom-medium block" style={{width:isMobile? '86px':''}}>{profileName} </span>
                                        <span style={{ position: 'absolute', left: isMobile?'126px':'168px' }}>{profileName != undefined && profileName != null && profileName != "" ? profilePrice : ""}</span>
                                    </p>
                                </li>
                                {profileCartValue}
                            </ul>
                        </div>
                    </div>

                    <div className="columns tiny-6 padding-vert-zero">
                        <div id="BundleSection" className="padding-left-small">
                            <ul className="margin-left-zero">
                                <li id="BundleDetails" className="" >
                                    <p className="margin-bottom-zero" style={{ display: cartName === "" ? 'none' : 'flex', position: 'relative' }}>
                                        <span id="BundleNameCSR" className="bold margin-bottom-medium block" style={{width:isMobile?'86px':''}}>{cartName}</span>
                                        <span style={{ position: 'absolute', left: isMobile?'117px':'162px' }}> {cartName != undefined && cartName != null && cartName != "" ? cartPrice : ""}</span>
                                    </p>
                                </li>
                                {newCartValue}
                            </ul>
                        </div>
                    </div>
                    <Line type="xLight" className={profileName != undefined && profileName != null || cartName != undefined && cartName != null ? "mm3-line-Reskin clear" : "hide"}  />                    
                </div>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        cart: state.cart,
        router: state.router,
        saveState: state.save,
        profileCart: state.profileCart
    }
}

export default connect(
    mapStateToProps,
)(CompareCartHeader);